import { put } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { z } from "zod";

interface UpdateAgentDataParams {
  stage: string;
}

const updateAgentResponseSchema = z.unknown();

export async function updateAgentData(updateData: UpdateAgentDataParams): Promise<unknown> {
  const response = await put({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/onboarding/updateAgent`,
    data: updateData,
    responseSchema: updateAgentResponseSchema,
  });
  return response.data;
}
